import * as yup from 'yup';

import { TGetStateResponseCompanyDE } from '../../../lapiOverrideTypesDE';

const monthRegex = /^(?:0?[1-9]|1[012])$/;

export const schema = yup.object().shape({
  // Used for changing schema when manual
  isManualInput: yup.boolean(),

  companyName: yup.string().required('benötigt'),
  crefoId: yup.string().when('isManualInput', {
    is: false,
    then: (schema) => schema.required('benötigt'),
  }),
  buildingNumber: yup.string().required('benötigt'),
  street: yup.string().required('benötigt'),
  postcode: yup
    .string()
    .required('benötigt')
    .matches(/^[0-9]{2}[0-9]{3}$/, 'ungültige Eingabe'),
  town: yup.string().required('benötigt'),
  legalForm: yup
    .string<NonNullable<TGetStateResponseCompanyDE['type']>>()
    .when('isManualInput', {
      is: true,
      then: (schema) => schema.required('benötigt'),
    }),
  startDateMonth: yup
    .string()
    .required('benötigt')
    .matches(monthRegex, 'ungültige Eingabe'),
  startDateYear: yup
    .string()
    .required('benötigt')
    .min(4, 'benötigt')
    .max(4, 'ungültige Eingabe'),
  last12MonthsTurnover: yup.string().required('benötigt'),
  website: yup
    .string()
    .matches(
      /^$|((http|https):\/\/)?[a-zA-Z0-9./?:@\-_=#]+\.([a-zA-Z0-9&./?:@\-_=#])*/,
      'Bitte geben Sie eine gültige Webadresse an',
    ),
});

export const minimumCompanyDataSchemaDE = yup.object().shape({
  companyName: yup.string().required(),
  street: yup.string().required(),
  postcode: yup.string().required(),
  town: yup.string().required(),
  startDateMonth: yup.string().required().matches(monthRegex),
  startDateYear: yup.string().required().min(4).max(4),
  last12MonthsTurnover: yup.string().required(),
});
